"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var addMenuTopAreaItem = function (menuData, menuItem) { return (__assign({}, menuData, { topArea: [menuItem].concat(menuData.topArea) })); };
exports.default = addMenuTopAreaItem;
